import React from 'react';
import {
    Box,
    Typography,
    IconButton,
    Avatar,
    useTheme,
    useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

const ModalHeader = ({ onClose }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{
            p: isMobile ? 2 : 3,
            background: theme.palette.background.header,
            position: 'relative',
            pt: isMobile ? 'env(safe-area-inset-top)' : 3
        }}>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    opacity: 0.1,
                    backgroundImage: 'radial-gradient(circle at 20px 20px, rgba(255,255,255,0.3) 2px, transparent 0)',
                    backgroundSize: '40px 40px'
                }}
            />
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                position: 'relative',
                pt: isMobile ? 1 : 0
            }}>
                <Avatar
                    sx={{
                        width: isMobile ? 48 : 56,
                        height: isMobile ? 48 : 56,
                        bgcolor: 'rgba(255,255,255,0.2)',
                        backdropFilter: 'blur(5px)'
                    }}
                >
                    <AccountBalanceIcon sx={{
                        color: theme.palette.text.header,
                        fontSize: isMobile ? 24 : 30
                    }} />
                </Avatar>
                <Box>
                    <Typography variant={isMobile ? "h6" : "h5"} sx={{
                        color: theme.palette.text.header,
                        fontWeight: 700,
                        mb: 0.5
                    }}>
                        Add Bank Account
                    </Typography>
                    <Typography variant="body2" sx={{ color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.8)' : 'rgba(255, 255, 255, 0.8)', opacity: 0.8, color: theme.palette.text.header }}>
                        Enter your bank account details
                    </Typography>
                </Box>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 0,
                        top: isMobile ? 0 : 0,
                        color: theme.palette.text.header,
                        '&:hover': { bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(255, 255, 255, 0.1)' } // Safe to leave hardcoded alpha for hover
                    }}
                >
                    <CloseIcon fontSize={isMobile ? "small" : "medium"} />
                </IconButton>
            </Box>
        </Box>
    );
};

export default ModalHeader;
